/**
 * Update :forLoggedInUser
 * @param {String} htmlContent
 * @param {Object} appUser
 * @returns {String} updated HTML string
 */
export function applyLoggedInUserClass (htmlContent, appUser) {
  if (!appUser) {
    htmlContent = htmlContent.replaceAll(':forLoggedInUser', 'is-hidden')
  }

  return htmlContent
}
